import {Component, inject, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CartService} from '../../../services/cart.service';
import {THEME_CONFIG} from '../../../../environments/tokens/theme.token';
import {MatButton} from '@angular/material/button';
import {DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-order-discount-dialog',
  templateUrl: './order-discount-dialog.component.html',
  styleUrl: './order-discount-dialog.component.scss',
  imports: [MatButton, DecimalPipe],
  standalone: true
})
export class OrderDiscountDialogComponent {
  private cartService = inject(CartService);
  protected readonly themeConfig = inject(THEME_CONFIG)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      promotion: any;
      rule: any;
      cartTotal: number;
      isPalierChange?: boolean  // ← NOUVEAU
    },
    private dialogRef: MatDialogRef<OrderDiscountDialogComponent>
  ) {
  }

  getDiscountText(): string {
    const r = this.data.rule.reduction;
    if (!r) return 'Réduction appliquée !';
    if (r.type === 'FIXED_AMOUNT') {
      return this.data.isPalierChange
        ? `🎉 Votre remise a été mise à jour ! Vous bénéficiez maintenant d'une réduction de ${r.value}€ sur votre commande !`
        : `🎉 Vous bénéficiez d'une réduction de ${r.value}€ sur votre commande !`;
    }
    if (r.type === 'PERCENTAGE') {
      return this.data.isPalierChange
        ? `🎉 Votre remise a été mise à jour ! Vous bénéficiez maintenant d'une réduction de ${Math.round(r.value * 100)}% sur votre commande !`
        : `🎉 Vous bénéficiez d'une réduction de ${Math.round(r.value * 100)}% sur votre commande !`;
    }
    return 'Réduction appliquée !';
  }

  getTitleText(): string {
    return this.data.isPalierChange
      ? '🆙 Nouveau palier atteint !'
      : this.data.promotion.title;
  }

  getDiscountedTotal(): number {
    const r = this.data.rule?.reduction;
    const total = this.cartService.totalPrice();
    if (!r) return total;
    if (r.type === 'PERCENTAGE') {
      return Math.round((total * (1 - r.value)) * 100) / 100;
    }
    if (r.type === 'FIXED_AMOUNT') {
      return Math.round(Math.max(0, total - r.value) * 100) / 100;
    }
    return total;
  }

  close(): void {
    this.dialogRef.close('ok');
  }
}
